export default {
  // Nav
  "nav.home": "Home",
  "nav.woonlening": "Woonlening",
  "nav.loa": "Leningen op afbetaling",
  "nav.wieZijnWij": "Wie zijn wij?",
  "nav.contact": "Contact",

  // Footer
  "footer.partners": "Partners",
  "footer.simuleer": "Simuleer uw krediet",
  "footer.juridisch": "Juridische mededelingen",
  "footer.privacy": "Privacy",
  "footer.hours": "Ma - Vrij: 9.00 - 12.30 & 13.30 - 18.00",
  "footer.saturday": "Zaterdagmiddag op afspraak",
  "footer.rights": "MADE BY TEKDAM. ALL RIGHTS RESERVED.",

  // Home - Hero
  "home.hero.title": "",
  "home.hero.body": " - Vertrouwd kredietadvies sinds 1995",
  "home.hero.sub1": "Al drie decennia vertrouwen particulieren en zelfstandigen op Haskrediet voor deskundig en persoonlijk kredietadvies.",
  "home.hero.sub1b": "Vandaag staan wij klaar om ook uw plannen te realiseren.",
  "home.hero.sub2": "Bent u de volgende?",

  // Home - Simuleer
  "home.sim.title": "Simuleer uw lening",
  "home.sim.subtitle": "Bereken uw lening in enkele klikken",
  "home.sim.body": "Ontdek vandaag nog uw financiële mogelijkheden. Met de online simulatie van Haskrediet berekent u in enkele seconden hoeveel u kunt lenen en welke maandelijkse aflossing daarbij hoort. Snel, eenvoudig en volledig vrijblijvend. Zo krijgt u meteen een helder inzicht in uw budget en kunt u goed voorbereid de volgende stap zetten.",
  "home.sim.example": "Voorbeeld:",
  "home.sim.exLine1": "Lening op afbetaling - U leent €8.000 over 48 maanden",
  "home.sim.exLine2": "Maandelijkse aflossing: €183,86 - Totaal terug te betalen: €8.825,28",
  "home.sim.jkp": "JKP:",
  "home.sim.rente": "Vaste of variabele rentevoet:",

  // Simulation type toggle
  "sim.type.woon": "Woonlening",
  "sim.type.loa": "Lening op afbetaling",

  // Home - Loan card
  "loan.personalLoan": "Persoonlijke lening",
  "loan.amount": "Bedrag",
  "loan.duration": "Looptijd (maanden)",
  "loan.monthly": "Maandelijks",
  "loan.months": "maanden",
  "loan.personalCredit": "Persoonlijke krediet",
  "loan.maxAmount": "Het maximumbedrag is {max}.",
  "loan.totalRepay": "Totaal terug te betalen",
  "loan.totalInterest": "Totaal aan intresten",
  "loan.chooseRateHint": "Kies een rentevoet om uw simulatie te berekenen.",
  "loan.apply": "Aanvragen",
  "loan.onlineApply": "Online Aanvraag",

  // Contact form
  "contact.title": "Contactformulier",
  "contact.firstName": "Voornaam",
  "contact.lastName": "Naam",
  "contact.email": "E-mail",
  "contact.phone": "Telefoonnummer",
  "contact.send": "Versturen",
  "contact.bubble": "Laten we in contact blijven",
  "contact.bubbleText": "Voor meer informatie over onze kredietoplossingen kun je in de formulier uw gegevens achterlaten. Wij nemen zo snel mogelijk contact met u op.",
  "contact.message": "Uw bericht:",
  "contact.success": "Uw bericht is succesvol verzonden!",
  "contact.error": "Er is iets misgegaan. Probeer het later opnieuw.",

  // Woonlening
  "woon.title": "WOONLENING",
  "woon.heroTitle": "Haskrediet - Al sinds 1995 uw betrouwbare partner voor woonkredieten.",
  "woon.heroBody": "Dromen van een eigen woning?",
  "woon.heroText": "Met meer dan 30 jaar ervaring begeleidt Haskrediet u naar het woonkrediet dat perfect aansluit bij uw situatie. Onafhankelijk advies, scherpe voorwaarden en persoonlijke begeleiding van aanvraag tot akte.",
  "woon.sim.title": "Simuleer uw woonlening",
  "woon.sim.subtitle": "Bereken uw maandelijkse aflossing",
  "woon.sim.years": "jaar",
  "woon.startRequest": "Start uw aanvraag",
  "woon.desiredAmount": "GEWENST BEDRAG",
  "woon.slogan": "Uw droom, onze zorg.",
  "woon.val1": "Een huis kopen, verbouwen of herfinancieren? Bij {brand} begint alles met luisteren. We willen begrijpen wat jij echt belangrijk vindt: je toekomst, je comfort, je ritme...",
  "woon.val2": "We geloven in geen standaardformules. Elke lening is uniek, omdat elke klant dat ook is. Daarom zoeken we samen naar een oplossing die past bij jouw situatie, vandaag en morgen.",
  "woon.val3": "Onze experts begeleiden je met helder advies, eerlijke voorwaarden en een menselijke aanpak.",
  "woon.val4": "Geen loze beloften, maar duidelijke antwoorden en echte betrokkenheid.",
  "woon.cta": "Met {brand} maak je keuzes met vertrouwen: stap voor stap, op jouw tempo.",

  // Leningen
  "len.title": "LENINGEN OP AFBETALING",
  "len.heroLine1": "Uw plannen verdienen een financiering op maat.",
  "len.heroText1": "Of het nu gaat om een nieuwe wagen, een renovatie, een droomreis of onverwachte uitgaven: bij ons beschikt u snel over de nodige financiële ruimte. Wij bekijken samen uw situatie en zoeken een oplossing die perfect aansluit bij uw budget en toekomstplannen. Transparant, persoonlijk en zonder verrassingen.",
  "len.heroTagline": "Snel geregeld. Duidelijke voorwaarden. Persoonlijke begeleiding.",
  "len.whatCanWeDo": "Wat kunnen we voor jou betekenen?",
  "len.personal": "Persoonlijke lening",
  "len.personalDesc": "Een persoonlijk project, een grote aankoop of een onverwachte uitgave? Met een persoonlijke lening bij Haskrediet realiseer je jouw plannen zonder zorgen.",
  "len.auto": "Autolening",
  "len.autoDesc": "Op je naar nieuwe of tweedehands auto? Met onze autolening rij je snel en voordelig weg. Scherpe financiering die rijdt op jouw tempo.",
  "len.reno": "Renovatielening",
  "len.renoDesc": "Je woning vernieuwen of verduurzamen? Onze renovatielening geeft jouw thuis een tweede leven - op jouw budget afgestemd.",
  "len.regroup": "Hergroepering van kredieten",
  "len.regroupDesc": "Meerdere lopende leningen? Wij bundelen ze tot één overzichtelijke aflossing - vaak voordeliger, altijd duidelijker.",
  "len.chooseProject": "Kies Uw Project",
  "len.desiredAmount": "Gewenst Bedrag",
  "len.paymentCount": "Aantal Betaling Gewenst?",
  "len.clickHere": "Klik hier",
  "len.dur": "Duur",
  "len.totalBack": "Totaal Terug Te Betalen:",

  // Broker info
  "home.broker.title": "Waarom kiezen voor Haskrediet?",
  "home.broker.intro1": "Al sinds 1995 begeleidt Haskrediet klanten bij het vinden van de juiste kredietoplossing. Dankzij meer dan 30 jaar ervaring hebben wij een sterke reputatie opgebouwd als betrouwbare en professionele kredietmakelaar.",
  "home.broker.intro2": "",
  "home.broker.troeven": "Onze troeven",
  "home.broker.ervaring.title": "Ruime ervaring en expertise",
  "home.broker.ervaring.text": "Sinds 1995 volgen wij de kredietmarkt van dichtbij. Hierdoor kunnen wij onze klanten deskundig adviseren en begeleiden bij belangrijke financiële beslissingen.",
  "home.broker.persoonlijk.title": "Persoonlijke aanpak",
  "home.broker.persoonlijk.text": "Wij luisteren naar uw wensen, analyseren uw situatie en zoeken een oplossing die perfect aansluit bij uw behoeften.",
  "home.broker.onafhankelijk.title": "Onafhankelijk advies",
  "home.broker.onafhankelijk.text": "Als kredietmakelaar vergelijken wij verschillende kredietverstrekkers. Zo helpen wij u een formule te vinden met voorwaarden die het best bij uw profiel passen.",
  "home.broker.begeleiding.title": "Volledige begeleiding",
  "home.broker.begeleiding.text": "Van de eerste aanvraag tot de uiteindelijke afhandeling van uw dossier staan wij aan uw zijde. U kunt rekenen op duidelijke communicatie en professionele ondersteuning gedurende het hele proces.",
  "home.broker.vertrouwen.title": "Vertrouwen en transparantie",
  "home.broker.vertrouwen.text": "Al meer dan drie decennia kiezen klanten voor Haskrediet vanwege onze eerlijke aanpak, transparante informatie en betrouwbare dienstverlening.",
  "home.broker.aanbod.title": "Breed aanbod",
  "home.broker.aanbod.text": "Van hypothecaire leningen en persoonlijke kredieten tot leasing en beroepskredieten: bij Haskrediet vindt u alle financieringsoplossingen onder één dak.",
  "home.broker.closing.title": "Meer dan 30 jaar ervaring in uw voordeel",
  "home.broker.closing.text": "Bij Haskrediet geloven wij dat een goed kredietadvies begint met luisteren naar de klant. Daarom zetten wij ons elke dag in om financiële oplossingen op maat aan te bieden, ondersteund door ervaring, expertise en persoonlijke service.",
  "home.broker.closing.tagline": "Haskrediet - uw vertrouwde kredietpartner sinds 1995.",

  // Simulation info
  "home.sim.free": "Start uw gratis simulatie - dit is volledig vrijblijvend en zonder verplichting.",

  // Loan calculator
  "loan.rate": "Jaarlijkse rentevoet (%)",
  "loan.amountInfo.woon": "Het gewenste bedrag voor een woonlening ligt tussen €25.000 en €3.000.000.",
  "loan.amountInfo.loa": "Het gewenste bedrag voor een lening op afbetaling ligt tussen €500 en €99.999,99.",
  "loan.durationInfo.woon": "De looptijd voor een woonlening ligt tussen 5 en 30 jaar.",
  "loan.durationInfo.loa": "De looptijd hangt af van het geleende bedrag:",
  "loan.durationTable.amount": "Bedrag",
  "loan.durationTable.maxDuration": "Max. looptijd",
  "loan.durationTable.above": "Daarboven",
  "loan.rateInfo": "U kiest hier zelf een rentevoet voor uw simulatie. Dit is niet het definitieve tarief. Het werkelijke percentage hangt af van verschillende factoren en wordt bepaald na persoonlijk advies van HASKREDIET.",

  // Footer
  "footer.maps": "ROUTE",

  // Verzekeringen
  "nav.verzekeringen": "Verzekeringen",
  "verz.title": "VERZEKERINGEN",
  "verz.intro": "Naast kredietoplossingen bieden wij ook een uitgebreid aanbod van verzekeringen aan. Ontdek ons volledige aanbod op onze verzekeringenpagina.",
  "verz.link": "Naar Haskrediet Verzekeringen",

  // Leasing
  "nav.leasing": "Leasing",
  "leasing.title": "LEASING AANVRAGEN",
  "leasing.heroTitle": "Investeer vandaag, betaal gespreid",
  "leasing.heroText": "Wilt u een wagen, bestelwagen, machine of professioneel materiaal financieren zonder uw beschikbare kapitaal aan te spreken? Met leasing via Haskrediet geniet u van een flexibele en fiscaal interessante oplossing, volledig afgestemd op uw onderneming.",
  "leasing.whyTitle": "Waarom kiezen voor leasing via Haskrediet?",
  "leasing.why1": "Snelle en persoonlijke behandeling van uw dossier",
  "leasing.why2": "Financiering op maat van uw onderneming",
  "leasing.why3": "Behoud van uw werkkapitaal en financiële ruimte",
  "leasing.why4": "Mogelijkheid tot aankoop op het einde van het contract",
  "leasing.why5": "Transparante voorwaarden, zonder verrassingen",
  "leasing.why6": "Meer dan 30 jaar ervaring in financiële oplossingen",
  "leasing.whatTitle": "Voor welke investeringen?",
  "leasing.whatIntro": "Wij begeleiden u bij de leasing van onder meer:",
  "leasing.what1": "Personenwagens en bedrijfswagens",
  "leasing.what2": "Bestelwagens en vrachtwagens",
  "leasing.what3": "Machines en productiemateriaal",
  "leasing.what4": "Bouw- en landbouwmaterieel",
  "leasing.what5": "IT- en kantoorapparatuur",
  "leasing.what6": "Medische en professionele uitrusting",
  "leasing.customTitle": "Een oplossing op maat van uw activiteit",
  "leasing.customText": "Elke onderneming is uniek. Daarom bekijken wij samen met u welke leasingformule het beste aansluit bij uw behoeften, uw budget en uw groeiplannen.",
  "leasing.customTagline": "Snel, deskundig en persoonlijk begeleid.",
  "leasing.ctaTitle": "Vraag vrijblijvend uw leasing aan",
  "leasing.ctaText": "Wilt u weten welke mogelijkheden er zijn voor uw investering? Onze specialisten staan klaar om u te adviseren en een voorstel op maat uit te werken.",
  "leasing.ctaClosing": "Vraag vandaag nog uw leasing aan en realiseer uw professionele plannen met vertrouwen.",
  "leasing.ctaTagline": "Haskrediet - Uw betrouwbare partner in financiering sinds 1995.",
  "leasing.contactBtn": "Contacteer ons",
  "leasing.formSubject": "Nieuwe leasingaanvraag - Haskrediet",

  // Ondernemers
  "nav.ondernemers": "Ondernemers",
  "ond.title": "BEROEPSKREDIETEN & INVESTERINGSKREDIETEN",
  "ond.heroTitle": "Geef uw onderneming de ruimte om te groeien",
  "ond.heroText1": "Wilt u investeren in de toekomst van uw zaak? Met een beroepskrediet of investeringskrediet via Haskrediet beschikt u over de financiële middelen om uw plannen te realiseren, zonder uw liquiditeit in gevaar te brengen.",
  "ond.heroText2": "Of u nu start, uitbreidt of moderniseert, wij begeleiden u met een financieringsoplossing die aansluit bij de ambities van uw onderneming.",
  "ond.whatTitle": "Waarvoor kunt u een investeringskrediet gebruiken?",
  "ond.what1": "Aankoop of verbouwing van bedrijfspanden",
  "ond.what2": "Machines en productiemateriaal",
  "ond.what3": "Voertuigen en bedrijfswagens",
  "ond.what4": "IT-infrastructuur en digitalisering",
  "ond.what5": "Uitbreiding van uw activiteiten",
  "ond.what6": "Overname van een handelszaak",
  "ond.what7": "Financiering van professioneel materiaal",
  "ond.what8": "Versterking van uw werkkapitaal",
  "ond.whyTitle": "Waarom kiezen voor Haskrediet?",
  "ond.adv1.title": "Persoonlijk advies op maat",
  "ond.adv1.text": "Elke onderneming is uniek. Daarom zoeken wij samen met u naar de financieringsoplossing die past bij uw activiteit en toekomstplannen.",
  "ond.adv2.title": "Meer dan 30 jaar ervaring",
  "ond.adv2.text": "Sinds 1995 begeleiden wij zelfstandigen, vrije beroepen, KMO's en ondernemers met deskundig en onafhankelijk advies.",
  "ond.adv3.title": "Snelle en efficiënte behandeling",
  "ond.adv3.text": "Wij analyseren uw dossier zorgvuldig en zorgen voor een vlotte opvolging, zodat u zich kunt concentreren op uw onderneming.",
  "ond.adv4.title": "Transparante voorwaarden",
  "ond.adv4.text": "Duidelijke afspraken en een financiering die aansluit bij uw mogelijkheden en doelstellingen.",
  "ond.closingTitle": "Investeer met vertrouwen. Groei met zekerheid.",
  "ond.closingText": "Een sterke onderneming verdient een sterke financiële partner. Haskrediet helpt u bij het realiseren van uw investeringsprojecten met professioneel advies en oplossingen op maat.",
  "ond.closingCta": "Vraag vandaag nog vrijblijvend uw beroepskrediet of investeringskrediet aan.",
  "ond.closingTagline": "Haskrediet - Al meer dan 30 jaar de betrouwbare partner voor ondernemers en zelfstandigen.",
  "ond.contactBtn": "Contacteer ons",
  "ond.formSubject": "Nieuwe aanvraag beroepskrediet - Haskrediet",

  // Wie zijn wij
  "wie.title": "WIE ZIJN WIJ?",
  "wie.heroIntro1": "Als Krediet Makelaar begeleiden wij particulieren en ondernemers bij het vinden van de meest geschikte financieringsoplossing. Dankzij onze onafhankelijke positie vergelijken wij verschillende kredietverstrekkers en zoeken wij naar een formule die aansluit bij uw financiële situatie, wensen en toekomstplannen.",
  "wie.heroIntro2": "Wij geloven dat een krediet meer is dan alleen een lening. Het is een belangrijke financiële beslissing die vraagt om deskundig advies, transparantie en persoonlijke begeleiding. Daarom nemen wij de tijd om uw dossier grondig te analyseren en alle mogelijkheden helder toe te lichten.",
  "wie.heroIntro3": "Of het nu gaat om een woonkrediet, herfinanciering, investeringskrediet of een andere financieringsbehoefte, wij staan u bij tijdens het volledige traject: van de eerste simulatie tot de uiteindelijke ondertekening.",
  "wie.values.title": "Onze kernwaarden zijn:",
  "wie.values.onafhankelijk": "Onafhankelijk advies: wij vergelijken verschillende aanbieders om de beste oplossing voor u te vinden.",
  "wie.values.begeleiding": "Persoonlijke begeleiding: elke klant en elk dossier is uniek.",
  "wie.values.transparantie": "Transparantie: duidelijke communicatie zonder verrassingen.",
  "wie.values.deskundigheid": "Deskundigheid: actuele kennis van de kredietmarkt en financiële regelgeving.",
  "wie.closing1": "Als Krediet Makelaar streven wij ernaar om financiering toegankelijk, begrijpelijk en zorgeloos te maken. Zo kunt u met vertrouwen de juiste financiële keuzes maken.",
  "wie.closing2": "Krediet Makelaar - uw betrouwbare partner voor kredietadvies op maat.",

  // Juridische mededeling
  "jur.title": "JURIDISCHE MEDEDELING",
  "jur.companyTitle": "Bedrijfsgegevens",
  "jur.btwLabel": "BTW",
  "jur.activityTitle": "Activiteit",
  "jur.activityText": "HASKREDIET BV is actief als bemiddelaar in hypothecair krediet en consumentenkrediet. Wij treden op als kredietmakelaar en vergelijken de aanbiedingen van verschillende kredietgevers om de meest geschikte financieringsoplossing voor onze klanten te vinden.",
  "jur.fsmaTitle": "Toezichthoudende autoriteit",
  "jur.fsmaText": "HASKREDIET BV is ingeschreven als bemiddelaar in hypothecair krediet en consumentenkrediet bij de FSMA (Autoriteit voor Financiële Diensten en Markten), Congresstraat 12-14, 1000 Brussel.",
  "jur.fsmaCheck": "U kunt onze inschrijving verifiëren op de website van de FSMA: www.fsma.be.",
  "jur.disclaimerTitle": "Disclaimer",
  "jur.disclaimerText1": "De informatie op deze website is louter informatief en vormt geen aanbod tot het verlenen van een krediet. Elke kredietaanvraag wordt individueel beoordeeld en is onderworpen aan de goedkeuring van de kredietgever.",
  "jur.disclaimerText2": "De simulaties op deze website zijn indicatief en niet-bindend. De werkelijke voorwaarden kunnen afwijken na analyse van uw persoonlijke situatie.",
  "jur.liabilityTitle": "Aansprakelijkheid",
  "jur.liabilityText1": "HASKREDIET BV besteedt de grootste zorg aan de inhoud van deze website, maar kan geen garantie bieden op de volledigheid, juistheid of actualiteit van de verstrekte informatie.",
  "jur.liabilityText2": "HASKREDIET BV kan niet aansprakelijk worden gesteld voor eventuele schade die voortvloeit uit het gebruik van deze website of de informatie die erop te vinden is.",
  "jur.ipTitle": "Intellectueel eigendom",
  "jur.ipText": "Alle teksten, afbeeldingen, logo's en andere elementen op deze website zijn beschermd door het auteursrecht en mogen niet worden gereproduceerd, verspreid of gebruikt zonder voorafgaande schriftelijke toestemming van HASKREDIET BV.",
  "jur.disputeTitle": "Geschillen",
  "jur.disputeText": "Op deze juridische mededeling en het gebruik van deze website is het Belgisch recht van toepassing. Eventuele geschillen vallen onder de exclusieve bevoegdheid van de rechtbanken van Gent.",

  // Privacy
  "priv.title": "PRIVACYBELEID",
  "priv.intro": "HASKREDIET BV hecht veel belang aan de bescherming van uw persoonsgegevens. Dit privacybeleid legt uit welke gegevens wij verzamelen, waarom wij dat doen en hoe wij uw privacy beschermen, in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG/GDPR).",
  "priv.controllerTitle": "Verantwoordelijke voor de verwerking",
  "priv.dataTitle": "Welke gegevens verzamelen wij?",
  "priv.dataText": "Wij kunnen de volgende persoonsgegevens verzamelen wanneer u contact met ons opneemt of een aanvraag indient:",
  "priv.data1": "Naam en voornaam",
  "priv.data2": "E-mailadres",
  "priv.data3": "Telefoonnummer",
  "priv.data4": "Berichten die u via het contactformulier verstuurt",
  "priv.purposeTitle": "Waarvoor gebruiken wij uw gegevens?",
  "priv.purposeText": "Uw persoonsgegevens worden uitsluitend gebruikt voor de volgende doeleinden:",
  "priv.purpose1": "Het beantwoorden van uw vragen en aanvragen",
  "priv.purpose2": "Het verlenen van advies over krediet- en financieringsoplossingen",
  "priv.purpose3": "Het opvolgen van uw dossier",
  "priv.legalTitle": "Rechtsgrond",
  "priv.legalText": "De verwerking van uw persoonsgegevens is gebaseerd op uw toestemming (bij het invullen van het contactformulier) en op de uitvoering van een overeenkomst of precontractuele maatregelen.",
  "priv.retentionTitle": "Bewaartermijn",
  "priv.retentionText": "Uw persoonsgegevens worden niet langer bewaard dan noodzakelijk voor de doeleinden waarvoor ze zijn verzameld, tenzij een langere bewaartermijn wettelijk verplicht is.",
  "priv.sharingTitle": "Delen van gegevens",
  "priv.sharingText": "Wij delen uw persoonsgegevens niet met derden, tenzij dit noodzakelijk is voor de uitvoering van onze diensten (bijvoorbeeld met een kredietgever bij een kredietaanvraag) of wanneer wij hiertoe wettelijk verplicht zijn.",
  "priv.rightsTitle": "Uw rechten",
  "priv.rightsText": "U heeft op elk moment het recht om:",
  "priv.right1": "Inzage te vragen in uw persoonsgegevens",
  "priv.right2": "Uw gegevens te laten verbeteren of aanvullen",
  "priv.right3": "Uw gegevens te laten verwijderen",
  "priv.right4": "De verwerking van uw gegevens te beperken",
  "priv.right5": "Bezwaar te maken tegen de verwerking van uw gegevens",
  "priv.rightsContact": "U kunt uw rechten uitoefenen door contact op te nemen via info@haskrediet.be of 09/267.30.30.",
  "priv.cookieTitle": "Cookies",
  "priv.cookieText": "Deze website kan gebruik maken van cookies om de gebruikerservaring te verbeteren. Door de website te blijven gebruiken, stemt u in met het gebruik van cookies.",
  "priv.changeTitle": "Wijzigingen",
  "priv.changeText": "HASKREDIET BV behoudt zich het recht voor om dit privacybeleid op elk moment te wijzigen. De meest recente versie is steeds beschikbaar op deze pagina.",

  // Disclaimer
  "loan.disclaimer": "Lening onder voorbehoud van aanvaarding dossier",

  // Global
  "global.loanCost": "Let op, geld lenen kost ook geld.",
} as Record<string, string>;
